import React, { useState } from 'react';

const AsButton = ({
    type = 'button',
    disabled = false,
    useSecondaryStyle = false,
    useTertiaryStyle = false,
    handleClick,
    dataId,
    hoverStyle,
    ...props
}) => {
    const [isHovering, setIsHovering] = useState(false);

    const primaryColourScheme = {
        // Amber
        border: '1px solid #ff7d00',
        backgroundColor: isHovering ? '#ffc134' : '#faa800'
    };

    const secondaryColourScheme = {
        // Light Orange
        border: '1px solid #ffb50c',
        backgroundColor: isHovering ? '#ffffff' : `#fdf1d6`
    };

    const tertiaryColourScheme = {
        // White
        ...(isHovering
            ? {
                  border: '1px solid #ffb50c',
                  backgroundColor: `#fdf1d6`
              }
            : {
                  border: '2px solid #cccccc',
                  backgroundColor: `#ffffff`
              })
    };

    const disabledColourScheme = {
        backgroundColor: '#cccccc', // Grey
        border: '1px solid #a6a6a6'
    };

    const buttonStyle = {
        fontFamily: 'Roboto',
        fontSize: '18px',
        fontWeight: 500,
        width: '150px',
        height: '40px',
        borderRadius: '5px',
        color: '#000000',
        cursor: disabled ? 'default' : 'pointer',
        ...(disabled
            ? disabledColourScheme
            : {
                  ...primaryColourScheme,
                  ...(useSecondaryStyle ? { ...secondaryColourScheme } : {}),
                  ...(useTertiaryStyle ? { ...tertiaryColourScheme } : {})
              }),
        ...props.style,
        ...(!disabled && typeof hoverStyle === 'object' && isHovering
            ? { ...hoverStyle }
            : {})
    };

    return (
        <button
            {...props}
            className='button'
            type={type}
            disabled={disabled}
            onClick={handleClick}
            data-id={dataId}
            style={buttonStyle}
            onMouseOver={() => setIsHovering(true)}
            onMouseOut={() => setIsHovering(false)}
        >
            {props.children}
        </button>
    );
};

export default AsButton;
